/**
 * ui
 *
 * @author Shigq
 * @date 2021/11/9 14:35
 */
// plugins
var _elementPlus = require('./plugins/element-plus')
var _i18n = require('./plugins/i18n')
// components
var _SrDrag = require('./components/sr-drag')
var _SrTblPagination = require('./components/sr-tbl-pagination')
var _SrTimerBtn = require('./components/sr-timer-btn')
// compositions
var _tableComp = require('./compositions/table')
var _formComp = require('./compositions/form')
var _validatorComp = require('./compositions/validator')
// config
var _componentConfig = require('./config/component.config')
var _netConfig = require('./config/net.config')
var _settingConfig = require('./config/setting.config')
var _fileConfig = require('./config/file.config')
// utils
var _vab = require('./utils/vab')

var ui = {
	plugins: {
		elementPlus: _elementPlus,
		i18n: _i18n
	},
	components: {
		SrDrag: _SrDrag.default,
		SrTblPagination: _SrTblPagination.default,
		SrTimerBtn: _SrTimerBtn.default,
	},
	compositions: {
		tableComp: _tableComp.default,
		formComp: _formComp.default,
		validatorComp: _validatorComp.default,
	},
	config: {
		componentConfig: _componentConfig,
		netConfig: _netConfig,
		settingConfig: _settingConfig,
		fileConfig: _fileConfig
	},
	utils: {
		vab: _vab
	}
}

console.log('ui init', ui)

module.exports = ui
